import { buildR2AssetsImageUrl } from "@saas/shared/lib/image-url-builder";
import type { HopHopHopDanceQualityId } from "./hop-hop-hop-dance-preset";

export interface HopHopHopDanceShowcaseClip {
	id: string;
	quality: HopHopHopDanceQualityId;
	orientation: "portrait";
	onSite: boolean;
	duration: number;
	videoUrl: string;
	previewVideoUrl: string;
	poster: string;
	hasAudio: boolean;
	inputImages: string[];
}

const R2_BASE = "home/showcase/hop-hop-hop-dance";
/**
 * 视频和 poster 地址的版本参数（assets 域边缘缓存一天，连 404 也缓存）；换片子时加一。
 * 从 1 起：HD 两条上传前本地 dev 已经请求过不带参数的地址，边缘缓存了 404（同 AI Tongue Kiss）。
 * 10/31 hd-duo 换成新 prompt 重出的版本、同名覆盖，跳到 3（2 换片前被请求过，缓存的是旧片）；
 * 11/01 hd-duo / hd-twin 换成加了「戳」的版本，跳到 4；
 * 11/01 HD 换 Seedance 2.0 完整版，hd-duo 换成新 HD 出的四下戳版，跳到 5（hd-twin 老公定留 Mini 版）
 */
const CLIP_VERSION = 5;

const clip = (
	id: string,
	onSite: boolean,
	duration: number,
	inputImages: string[],
): HopHopHopDanceShowcaseClip => {
	const videoUrl = buildR2AssetsImageUrl(
		`${R2_BASE}/clips/${id}-720p.mp4?v=${CLIP_VERSION}`,
	);
	return {
		id,
		quality: "hd",
		orientation: "portrait",
		onSite,
		duration,
		videoUrl,
		previewVideoUrl: videoUrl,
		poster: buildR2AssetsImageUrl(
			`${R2_BASE}/posters/${id}-720p.jpg?v=${CLIP_VERSION}`,
		),
		hasAudio: true,
		inputImages,
	};
};

const FRIEND_A = buildR2AssetsImageUrl(`${R2_BASE}/refs/friend-a.jpg`);
const FRIEND_B = buildR2AssetsImageUrl(`${R2_BASE}/refs/friend-b.jpg`);

/**
 * 右栏 Examples 和下方样片区共用这一份，工作台只取前两条。老公 10/31 定 @pouzato7 的 AI 版放第一条。
 * - pouzato7：@pouzato7 10/25 的 AI 民间英雄版（约 2.6M 播放），取自 hophophopdance.org 托管的 720×1280 带声版，
 *   抓取 2026-10-31；外部片 onSite false，不出「Try this example」、不进 VideoObject，文案标原作者
 * - hd-duo / hd-twin：本页工作台 HD 出的样片（库 id 见 packages/scripts/hop-hop-hop-dance-showcase/README.md）
 * - nirami1：@nirami1 10/24 的走廊原片（参考片的出处），同站托管的 720×1280 带声版
 */
export const hopHopHopDanceShowcaseClips: HopHopHopDanceShowcaseClip[] = [
	clip("pouzato7", false, 7.709, []),
	clip("hd-duo", true, 8.057, [FRIEND_A, FRIEND_B]),
	clip("hd-twin", true, 8.057, [FRIEND_A]),
	clip("nirami1", false, 8.266, []),
];

/** 本页 HD 样片的正式上传日期 */
export const HOP_HOP_HOP_DANCE_SHOWCASE_UPLOADED_AT =
	"2026-11-01T01:43:42+00:00";
